<template>
    <div class="mysection">
        <h1>找回密码</h1>
        <div class="login_wx">
          <el-form ref="form" :model="form" :rules="forgetPasswordRules">
          <el-row class="el-form-item">
            <el-col :span="24">
              <el-form-item label=""  prop="phoneNumber">
            <el-input class="el-form-item" v-model="form.phoneNumber"  size="large" placeholder="输入手机号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row class="el-form-item">
                <el-col :span="24" class="forget_msg">
                  <el-form-item label="" prop="phoneCaptcha" >
                    <el-input v-model="form.phoneCaptcha" placeholder="短信验证码" class="m_input input_msgcode"></el-input>
                    <el-button type="primary" class="btn_login_msg" v-bind:class="{transparent:showCaptchaCodeButton}" @click="getForgetPwdCaptcha">{{btntxt}}</el-button>
                  </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="btn_large">
            <el-button v-on:click="toChangePwd" type="primary" size="large" class="btn_login">重设密码</el-button>
        </div>
    </div>
</template>
<script>
    import {reqWxForgetPwdCaptcha,reqGoWxChangePwd} from '../../api/weixin-api'
    export default {
        data(){
            return{
                wxstate:'',
                openid:'',
                btntxt: '获取验证码',
                showCaptchaCodeButton: false,
                countDownTime: 0,
                form: {
                    phoneNumber: '',
                    phoneCaptcha: '',
                },
              forgetPasswordRules:{
                phoneNumber: [
                  {required: true, message: '请输入手机号', trigger: 'blur'},
                ],
                phoneCaptcha: [
                  {required: true,message: '请输入验证码', trigger: 'blur'},
                ],
              }
            };
        },
        methods:{
            backLong(){
                this.$router.push({name:'wxLogin'});
            },
            toChangePwd(){
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.$message({
                            message: '请填写符合规则的信息',
                            type: 'warning'
                        });
                        return false;
                    }
                    let para = Object.assign({}, this.form);
                    this.$refs.form.validate((valid) => {
                      if (valid) {
                        reqGoWxChangePwd(para).then((res) => {
                          if (res.data.code === 4) {
                            this.$message({
                              message: '验证码失效',
                              type: 'warning'
                            });
                          } else if (res.data.data === 2) {
                            this.$message({
                              message: '验证成功，请您重新设置密码',
                              type: 'success'
                            });
                            this.$router.push({path: 'wxChangePwd', query: {phoneNumber: this.form.phoneNumber,openid:this.openid,wxstate:this.wxstate}});
                            console.info("==========phoneNumber" + this.form.phoneNumber);
                          } else if (res.data.code === 3) {
                            this.$message({
                              message: '验证码错误',
                              type: 'warning'
                            });
                            this.form.phoneCaptcha = '';
                          }
                        })
                      }
                    })
                    //=========校验
                }).catch(() => {
                });
            },
            timer: function () {
                if (this.countDownTime > 0) {
                    this.countDownTime--
                    this.btntxt = this.countDownTime + 'S'
                    setTimeout(this.timer, 1000)
                } else {
                    this.countDownTime = 0
                    this.btntxt = '获取验证码'
                    this.showCaptchaCodeButton = false
                }
            },
            //      获取手机验证码
            getForgetPwdCaptcha () {
                this.form.phoneCaptcha='';
                let para = Object.assign({}, this.form)
                if(para.phoneNumber===''||para.phoneNumber===null){
                    this.$message({
                        message: '请输入手机号',
                        type: 'warning'
                    });
                }else {
                    reqWxForgetPwdCaptcha(para).then((res) => {
                        if(res.data.data===1){
                            this.$message({
                                message: "短信验证码发送成功",
                                type: 'success'
                            });
                            this.showCaptchaCodeButton = true;
                            this.countDownTime = 120;
                            this.timer()
                        } else if(res.data.code===2){
                            this.$message({
                                message: "短信验证码发送失败",
                                type: 'error'
                            });
                        }else if(res.data.code===3){
                            this.$message({
                                message:"短信验证码发送异常",
                                type: 'error'
                            });
                        }else if(res.data.code===4){
                            this.$message({
                                message:"该手机号未绑定账号",
                                type: 'error'
                            });
                            this.form.phoneNumber='';
                        }
                    })
                }

            },

          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },

          backWxLogin:function(openid,wxstate) {
            pushHistory();
            function bodyScroll(){
              window.location.href='/wxLogin?openid='+openid+'&wxstate='+wxstate;
            }
            window.addEventListener("popstate",bodyScroll, false);
            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }
          }
        },
        mounted(){
            this.$store.dispatch('hideHF');
            this.isWechatBrowser();
          this.openid=this.$route.query.openid;
          this.wxstate=this.$route.query.wxstate;
          this.backWxLogin(this.openid,this.wxstate);
        },
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
    .transparent {
        pointer-events: none;
        filter: alpha(opacity=50); /*IE滤镜，透明度50%*/
        -moz-opacity: 0.5; /*Firefox私有，透明度50%*/
        opacity: 0.5; /*其他，透明度50%*/
    }
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxForgetPassword.vue